import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import { Moba } from "@/plugs";
import "@/assets/style/main.scss";

import Page from "@/components/page";

Vue.use(Page);

// Vue.config.productionTip = false;
new Moba({
  mounted: resp => {
    console.log(resp);
    new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});
